import { Search } from "react-bootstrap-table2-toolkit";
import {
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { GetApp } from "@material-ui/icons";
import { Refresh, Search as SearchIcon } from "@mui/icons-material";
import PrintButton from "components/_refactor/button/print";

export default function TableHeader({
  headerTitle,
  csvFileName,
  csvProps,
  showPrint,
  showSearch,
  selectRef,
  componentRef,
  searchProps,
  dataTable,
  extraActions,
  changeSearchPlaceholder,
  reshearch,
}) {
  const { SearchBar } = Search;
  return (
    <Grid
      container
      spacing={2}
      style={{ marginBottom: "1rem" }}
      alignItems="center"
    >
      <Grid item xs={12} sm={6}>
        <Typography variant="h2" color="textPrimary">
          {headerTitle}
          {reshearch && (
            <IconButton onClick={reshearch} size="small">
              <Refresh size="small" />
            </IconButton>
          )}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Grid container spacing={2} justify="flex-end" alignItems="center">
          <Grid item hidden={!extraActions}>
            {extraActions}
          </Grid>
          <Grid item hidden={!showSearch}>
            {showSearch && (
              <TextField
                label="Filtro"
                variant="outlined"
                size="small"
                value={searchProps.value}
                onChange={searchProps.onChange}
                placeholder={changeSearchPlaceholder ?? "Pesquisar"}
                endAdornment={<SearchIcon size="small" />}
              />
            )}
          </Grid>
          <Grid
            item
            hidden={
              !csvFileName || !csvProps || !dataTable || dataTable.length === 0
            }
          >
            {csvFileName && csvProps && dataTable && dataTable.length > 0 && (
              <Tooltip title="Exportar CSV da página">
                <IconButton onClick={csvProps.onExport} size="small">
                  <GetApp />
                </IconButton>
              </Tooltip>
            )}
          </Grid>
          <Grid item hidden={!showPrint}>
            {showPrint && (
              <PrintButton
                selectRef={selectRef}
                componentRef={componentRef}
                dataTable={dataTable}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
